import {
  GraduationCap,
  HandPointing,
  CursorText,
  FileArrowDown,
} from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";

export function StepsSection() {
  const { t } = useTranslation(["newLanding"]);
  return (
    <section className="flex flex-col items-center w-full px-4 py-10 sm:py-14 md:py-16 ">
      <GraduationCap className="mb-12" weight="bold" size={40} />
      <h2 className="text-2xl font-bold tracking-tight text-center sm:text-3xl md:text-4xl">
        {t("subHero.title")}
      </h2>
      <p className="mb-8 text-4xl leading-relaxed text-center whitespace-pre-line text-dark-green">
        {t("subHero.subtitle")}
      </p>
      <p className="max-w-2xl mb-8 text-sm leading-relaxed text-center whitespace-pre-line text-muted-foreground sm:text-base">
        {t("subHero.body")}
      </p>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        <div className="flex flex-col items-center gap-4">
          <HandPointing className="mt-4" size={48} weight="fill" />
          <p className="text-center whitespace-pre-line">
            {t("subHero.action.1")}
          </p>
        </div>
        <div className="flex flex-col items-center gap-4">
          <CursorText className="mt-4" size={48} weight="fill" />
          <p className="text-center whitespace-pre-line">
            {t("subHero.action.2")}
          </p>
        </div>
        <div className="flex flex-col items-center gap-4">
          <FileArrowDown className="mt-4 text-wrap" size={48} weight="fill" />
          <p className="text-center whitespace-pre-line">
            {t("subHero.action.3")}
          </p>
        </div>
      </div>
    </section>
  );
}
